/* eslint-disable */
// TODO: all the plugins should be checked, legacy code

// [HIGHCHARTS-10-MIGRATION-TAG]: Find and delete/clean all places like this once the migration ends
import { HIGHCHARTS_V10_VERSION, HIGHCHARTS_V8_VERSION } from './constants';

import addContour from './highcharts-contour';
import { getHighchartsV8 } from './getHighchartsV8';
import { getHighchartsV10 } from './getHighchartsV10';

import DOMPurify from 'dompurify';

const stripHTMLRecurse = o => {
  if (typeof o === 'string') {
    return DOMPurify.sanitize(o);
  }

  if (typeof o === 'object' && o !== null)
    Object.entries(o).forEach(([key, value]) => {
      if (typeof value === 'string') {
        o[key] = DOMPurify.sanitize(o[key]);
      } else if (Array.isArray(value)) {
        value.forEach((item, i) => {
          o[key][i] = stripHTMLRecurse(item);
        });
      } else if (typeof value === 'object') {
        o[key] = stripHTMLRecurse(value);
      }
    });

  return o;
};

export async function initHighcharts({ version = HIGHCHARTS_V10_VERSION } = {}) {
  const highchartsGetter = version === HIGHCHARTS_V8_VERSION ? getHighchartsV8 : getHighchartsV10;

  if (![HIGHCHARTS_V8_VERSION, HIGHCHARTS_V10_VERSION].includes(version)) {
    throw new Error(`Invalid highcharts version: ${version}`);
  }

  const {
    Highcharts,
    highchartsMore,
    HighchartsMulticolorSeries,
    addSolidGauge,
    addHeatmap,
    addBoost,
    addExporting,
    addXrange,
    addDumbbell,
    addPatternFill,
  } = highchartsGetter();

  /**
   * NOTE: Highchart has a bug for pie chart in v8.1.2
   *       issue link:  https://github.com/highcharts/highcharts/issues/13710
   *       workaround:
   *          import Highcharts from 'highcharts';
   *          window.Highcharts = Highcharts;
   */
  window.Highcharts = Highcharts;

  // NOTE: Temporary disable HTML filtering for duration of migration to v10, as this is the main breaking change in v10, should be removed after migration
  if (Highcharts.AST) {
    Highcharts.AST.bypassHTMLFiltering = true;
  }

  HighchartsMulticolorSeries(Highcharts);
  // NOTE: Highcharts patching. It should be done in one place before any chart in rendered
  // in order to avoid conflicts
  highchartsMore(Highcharts);
  addSolidGauge(Highcharts); // https://www.highcharts.com/docs/chart-and-series-types/angular-gauges
  addHeatmap(Highcharts); // https://www.highcharts.com/docs/chart-and-series-types/heatmap
  addBoost(Highcharts); // https://www.highcharts.com/docs/advanced-chart-features/boost-module
  addExporting(Highcharts); // https://www.highcharts.com/docs/export-module/export-module-overview
  addXrange(Highcharts); // https://www.highcharts.com/docs/advanced-chart-features/boost-module
  addDumbbell(Highcharts);
  addPatternFill(Highcharts);
  addContour(Highcharts);

  // fix security issue for Highcharts 8
  // https://github.com/highcharts/highcharts/security/advisories/GHSA-8j65-4pcq-xq95
  const originalChartFn = Highcharts.chart;
  Highcharts.chart = function (container, options = {}, ...restParams) {
    return originalChartFn(container, stripHTMLRecurse(options), ...restParams);
  };

  /**
   * Adjust default highcharts effects globally for better use in our apps
   *
   * 1. Stop animation for inactive series
   *    ref: https://api.highcharts.com/highcharts/plotOptions.series.states.inactive.enabled
   *
   */
  Highcharts.setOptions({
    plotOptions: {
      series: {
        states: {
          inactive: {
            enabled: false,
          },
        },
      },
    },
  });
}
